<template>
  <el-dialog destroy-on-close title="新增" v-model="dialogFormVisible" class="clearfix button_bg" :close-on-click-modal="false">
      <el-form style="max-height:380px;overflow:auto;" ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="120px" class="clearfix">
        <div class="common_dialog_box clearfix">
          <div class="item_one clearfix">
            <el-form-item label="账期:" class="item" prop="period">
              <el-date-picker @change="changePeiod" v-model="temp.period" type="month" placeholder="选择账期" size="mini" style="width:150px"></el-date-picker>
              （默认上一账期）
            </el-form-item>
            <el-form-item label="身份证号:" prop="idNo" class="item">
              <el-input v-model="temp.idNo" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计收入:" prop="salary" class="item">
              <el-input  type="number" v-model="temp.salary" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计免税收入:" prop="ljmssr" class="item">
              <el-input type="number" v-model.number="temp.ljmssr" style="width:90%;" size="mini"/>
            </el-form-item>
             <el-form-item label="累计减除费用:" prop="deductOther" class="item">
              <el-input  type="number" v-model.number="temp.deductOther" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计专项扣除:" prop="deductSocial" class="item">
              <el-input  type="number" v-model.number="temp.deductSocial" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计其他扣除:" class="item">
              <el-input  type="number" v-model.number="temp.qtkc" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="子女教育:" prop="childrenEducation" class="item">
              <el-input  type="number" v-model.number="temp.childrenEducation" style="width:90%;" size="mini"/>
            </el-form-item>

            <el-form-item label="继续教育:" prop="continuingEducation" class="item">
              <el-input  type="number" v-model.number="temp.continuingEducation" style="width:90%;" size="mini"/>
            </el-form-item>

            <el-form-item label="大病医疗:" prop="seriousIllness" class="item">
              <el-input  type="number" v-model.number="temp.seriousIllness" style="width:90%;" size="mini"/>
            </el-form-item>

            <el-form-item label="住房贷款:" prop="housingLoan" class="item">
              <el-input  type="number" v-model.number="temp.housingLoan" style="width:90%;" size="mini"/>
            </el-form-item>

            <el-form-item label="住房租金:" prop="housingRent" class="item">
              <el-input  type="number" v-model.number="temp.housingRent" style="width:90%;" size="mini"/>
            </el-form-item>

            <el-form-item label="赡养老人:" prop="support" class="item">
              <el-input  type="number" v-model.number="temp.support" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="婴幼儿照护费用:" prop="babyReduction" class="item">
              <el-input  type="number" v-model.number="temp.babyReduction" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计应纳所得额:" prop="amount" class="item">
              <el-input  type="number" v-model.number="temp.amount" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计应交税款:" prop="tax" class="item">
              <el-input  type="number" v-model.number="temp.tax" style="width:90%;" size="mini"/>
            </el-form-item>
            <el-form-item label="累计已交税款:" prop="taxEnd" class="item">
              <el-input  type="number" v-model.number="temp.taxEnd" style="width:90%;" size="mini"/>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取消</el-button>
        <el-button @click="createData()" type="primary" size="mini">确定</el-button>
        <!-- <qzf-button jz="false" button_code="ljsj_xzqd" type="primary" @click="createData()" size="mini">确定</qzf-button> -->
      </div>
    </el-dialog>
</template>

<script>
import { parseTime } from '@/utils'
import { salaryInitImport } from '@/api/salary.js'
export default {
  name: 'addInformation',
  props: {
    period: {
      type: String,
      default: "",
    },
    comIdInit: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      list: [],
      dialogFormVisible: false,
      temp: {
        period:this.period,
        // periodf:undefined,
        idNo: '',
        salary: undefined,
        ljmssr: undefined,
        deductSocial:undefined,
        deductOther:undefined,
        childrenEducation: undefined,
        continuingEducation: undefined,
        seriousIllness: undefined,
        housingLoan: undefined,
        housingRent: undefined,
        support:undefined,
        amount:undefined,
        babyReduction: undefined,
        tax:undefined,
        taxEnd:undefined,
        qtkc:undefined
      },
      rules: {
        period: [{ required: true, message: '请选择账期', trigger: 'change' }],
        idNo: [{ required: true, message: '请输入身份证号', trigger: 'change' }],
        salary: [{ required: true, message: '请输入累计收入', trigger: 'change' }],
        ljmssr: [{ required: false, message: '请输入累计免税收入', trigger: 'change' }],
        deductOther: [{ required: false, message: '请输入累计减除费用', trigger: 'change' }],
        deductSocial: [{ required: false, message: '请输入累计专项扣除', trigger: 'change' }],
        childrenEducation: [{ required: false, message: '请输入子女教育金额', trigger: 'change' }],
        continuingEducation: [{ required: false, message: '请输入继续教育金额', trigger: 'change' }],
        seriousIllness: [{ required: false, message: '请输入大病医疗金额', trigger: 'change' }],
        housingLoan: [{ required: false, message: '请输入住房贷款金额', trigger: 'change' }],
        housingRent: [{ required: false, message: '请输入住房租金金额', trigger: 'change' }],
        support: [{ required: false, message: '请输入赡养老人金额', trigger: 'change' }],
        babyReduction: [{ required: false, message: '请输入累计婴幼儿照护费用', trigger: 'change' }],
        amount: [{ required: false, message: '请输入累计应纳所得额', trigger: 'change' }],
        tax: [{ required: false, message: '请输入累计应交税款', trigger: 'change' }],
        taxEnd: [{ required: false, message: '请输入累计已交税款', trigger: 'change' }]
      },
      delall: [],
      contentStyleObj:{}, //高度变化
      comId:0
    };
  },
  created(){
    console.log(this.comIdInit);
    if(this.comIdInit){
      this.comId = this.comIdInit
    }else{
      this.comId = this.$store.getters['user/comInfo'].comId*1
    }
  },
  methods: {
    //弹窗
    openSalary(){
      this.dialogFormVisible = true
    },
    changePeiod(){
      if(this.temp.periodf){
        this.temp.period = parseTime(this.temp.periodf, "{y}{m}");
      }
    },
    resetTemp() {
      this.temp = {
        period:this.period,
        idNo: this.temp.idNo,
        salary: Number(this.temp.salary),
        ljmssr: Number(this.temp.ljmssr),
        deductSocial:Number(this.temp.deductSocial),
        deductOther:Number(this.temp.deductOther),
        childrenEducation: Number(this.temp.childrenEducation),
        continuingEducation: Number(this.temp.continuingEducation),
        seriousIllness: Number(this.temp.seriousIllness),
        housingLoan: Number(this.temp.housingLoan),
        housingRent: Number(this.temp.housingRent),
        support:Number(this.temp.support),
        amount:Number(this.temp.amount),
        babyReduction: Number(this.temp.babyReduction),
        tax:Number(this.temp.tax),
        taxEnd:Number(this.temp.taxEnd),
        qtkc:Number(this.temp.qtkc),
      }
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if(valid) {
          this.resetTemp()
          let param = {
            items:[this.temp],
            period : this.temp.period,
            comId: this.comId,
          }
          salaryInitImport(param).then(res => {
            if(res.data.msg == "success"){
              this.$message({
                message: '新增成功',
                type: 'success'
              });
              this.dialogFormVisible = false
              this.$emit("success")
            }
          })
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.item_one {
  display: flex;
  flex-wrap: wrap;
}
</style>